import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ToastService } from 'app/services/toast.service';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap, switchMap, tap, withLatestFrom } from 'rxjs/operators';
import * as fromActions from './actions'
import * as fromUser from 'app/state/user/reducer';
import { SubscriptionService } from 'app/services/dal/subscription.service';
import { Store } from '@ngrx/store';
import { VoucherService } from 'app/services/dal/voucher.service';
import { shouldLoadData, trackLoading } from '../effect-helpers';
import * as fromVoucher from './reducer';



@Injectable()
export class Effects {

  constructor(
    private store: Store,
    private actions$: Actions,
    private subscriptionService: SubscriptionService,
    private service: VoucherService,
    private toastService: ToastService
  ) { }



  getItems$ = createEffect(() => {

    return this.actions$
      .pipe(
        ofType(fromActions.loadItems),
        shouldLoadData(
          this.store,
          'vouchers',
          (action) => action.barId,
          fromVoucher.selectAllItems
        ),
        switchMap((action) =>
          trackLoading(
            this.store,
            'vouchers',
            action.barId,
            this.service.getItems(action.barId).pipe(
              map(items => fromActions.loadItemsSuccess({ items: items })),
              catchError(error => of(fromActions.loadItemsFailure({ error })))
            )
          )
        )
      );
  });



  addVoucher$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(fromActions.addVoucher),
        withLatestFrom(this.store.select(fromUser.selectBarId)),
        mergeMap(([action, barId]) => from(this.subscriptionService.addVoucher(action.code, barId))
          .pipe(
            map(success => fromActions.addVoucherSuccess({ success: success })),
            catchError((error: any) => {
              const errorMsg = error.message || 'An unknown error occurred';
              return of(fromActions.addVoucherFailure({ error: errorMsg }))
            })
          )
        )
      );
  });





  addVoucherSuccess$ = createEffect(
    () => {
      return this.actions$
        .pipe(
          ofType(
            fromActions.addVoucherSuccess
          ),
          tap((action) => {
            this.toastService.toastSuccess('Voucher added successfully!')
          }),
        )
    },
    { dispatch: false }
  );


  handleFetchError$ = createEffect(
    () => {
      return this.actions$
        .pipe(
          ofType(
            fromActions.addVoucherFailure
          ),
          tap((action) => {
            this.toastService.error(action.error)
          }),
        )
    },
    { dispatch: false }
  );


}

